import Vue from 'vue'
import axios from 'axios'

import Router from 'vue-router'
import Index from './views/index.vue'
import Login from './views/login.vue'
import Register from './views/register.vue'
import FindPassWord from './views/findPassWord.vue'
import Detail from './views/detail.vue'
import Detail1 from './views/detail1.vue'
import PaymentOrder from './views/paymentOrder.vue'
import PaymentOrderD from './views/paymentOrderD.vue'
// import demo from './views/demo.vue'
import ProductList from './views/productList.vue'
import { format } from 'url'


import User from './views/user.vue'
import Welcome from './components/user/welcome.vue'

//首页
import BackShouYe from './components/user/index/backindex.vue'
// 批量下单
import BatchOrder from './components/user/xiadan/batchOrder.vue'
import OutgotingOrder from './components/user/xiadan/outgotingOrder.vue'
import CustOrder from './components/user/xiadan/custOrder.vue'
import DaikeOrder from './components/user/xiadan/daikeOrder.vue'
// 资产中心
import Recharge from './components/user/zichan/recharge.vue'
import rechargelog from './components/user/zichan/rechargelog.vue'
import ReportForm from './components/user/zichan/reportForm.vue'
import OrderForm from './components/user/zichan/orderForm.vue'
import Consume from './components/user/zichan/consumeDetail.vue'

// 资产中心（新）
import Usermoney from './components/user/newbill/usermoney.vue'//余额流水
import Billrechange from './components/user/newbill/billrechange.vue'//充值报表
import Water from './components/user/newbill/water.vue'//流水报表
import Billindex from './components/user/newbill/billindex.vue'//消费报表
import Aftersale from './components/user/newbill/aftersale.vue'//售后退款
import Quxiaorechange from './components/user/newbill/quxiaorechange.vue'//取消退款
import Third from './components/user/newbill/third.vue'//第三方流水
import Monthlyreport from './components/user/newbill/monthlyreport.vue'//消费月报
// 订单中心
import AllOrder from './components/user/dingdan/allOrder.vue'
import AllOrderD from './components/user/dingdan/allOrderD.vue'
import FileList from './components/user/dingdan/fileList.vue'
import OrderRecyling from './components/user/dingdan/OrderRecycling.vue'
import BackOrder from './components/user/dingdan/backOrder.vue' //售后列表
import ApplySaleBack from './components/user/dingdan/applySaleBack.vue' //申请售后
// 个人中心
import UserInfo from './components/user/geren/userInfo.vue'
import FahuoAddress from './components/user/geren/fahuoaddress.vue'
import Address from './components/user/geren/address.vue'
import Safety from './components/user/geren/safety.vue'
//信息中心
import SystemNew from './components/user/xinxizhongxin/systemnew.vue'
import OrderReminder from './components/user/xinxizhongxin/dingdantixing.vue'
import Promotions from './components/user/xinxizhongxin/cuxiao.vue'

// 报价
import QuotePrice from './components/baojia/indexBox.vue'
import Content from './components/baojia/content.vue'
import QuoteIndex from './components/baojia/index.vue'

// 关于我们
import Aboutus from './views/aboutus.vue'
import Aboutour from './components/us/our/aboutour.vue'
import Equipment from './components/us/our/equipment.vue'
import Center from './components/us/our/center.vue'
import Contactus from './components/us/our/contactus.vue'

//购物指南
import Agreement from './components/us/user/agreement.vue'

//云盘
import YunPan from './components/user/yunpan/fileList.vue'



Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', redirect: '/index' },
    { path: '/index', component: Index, meta: { title: '首页' },
		beforeEnter: async (to, from, next) => {
		const { data: res } = await axios.post('/api/index/apidata')
        document.title = res.data.name;  
         next(); 
      }	
	},
    { path: '/login', component: Login, meta: { title: '登陆' } },
    { path: '/register', component: Register, meta: { title: '注册' } },
    { path: '/findPassWord', component: FindPassWord, meta: { title: '找回密码' } },
    { path: '/detail', component: Detail, meta: { title: '加载中' } },
	{ path: '/detail1', component: Detail1, meta: { title: '加载中' } },
    { path: '/productList', component: ProductList, meta: { title: '产品列表' } },
    {
      path: '/paymentOrder', component: PaymentOrder, meta: { title: '支付订单' },
      beforeEnter: async (to, from, next) => {
        let param = new URLSearchParams()
        param.append('token', window.localStorage.getItem('token'))
        if (window.sessionStorage.getItem('cartype')) {
          if (window.sessionStorage.getItem('cartype') == 2) {
            param.append('cartype', 2)
          } else if (window.sessionStorage.getItem('cartype') == 4) {
            param.append('cartype', 4)
          } else {
            param.append('cartype', 3)
          }
        } else {
          param.append('cartype', 1)
        }
        const { data: res } = await axios({
          method: 'post',
          url: 'api/car/detail',
          data: param
        })
        if (res.data.length > 0) {
          next()
          return
        }
        next('/order')
      }
    },

    {
      path: '/paymentOrderD', component: PaymentOrderD, meta: { title: '代客下单' },
      beforeEnter: async (to, from, next) => {
        let param = new URLSearchParams()
        param.append('token', window.localStorage.getItem('token'))
        param.append('cartype', 2)
        const { data: res } = await axios({
          method: 'post',
          url: 'api/car/detailD',
          data: param
        })

        if (res.data.length > 0) {
          next()
          return
        }
        next('/daikeOrder')
      }
    },
    {
      path: '/user', component: User, redirect: '/order', meta: { title: '用户中心' },
      children: [
        { path: '/backshouye', component: BackShouYe, meta: { title: '会员中心' } },
        { path: '/welcome', component: Welcome, meta: { title: '用户中心' } },
        { path: '/order', component: AllOrder, meta: { title: '订单管理' } },
        { path: '/orderD', component: AllOrderD, meta: { title: '订单管理' } },
        { path: '/fileList', component: FileList, meta: { title: '申请替换文件' } },
        { path: '/orderRecyling', component: OrderRecyling, meta: { title: '已取消的订单' } },
        { path: '/backorder', component: BackOrder, meta: { title: '售后记录' } },
        { path: '/applysaleback/:id', component: ApplySaleBack, meta: { title: '申请售后' } },
        { path: '/recharge', component: Recharge, meta: { title: '充值中心' } },
        { path: '/rechargelog', component: rechargelog, meta: { title: '充值记录' } },
        { path: '/consume', component: Consume, meta: { title: '消费明细' } },
        { path: '/reportform', component: ReportForm, meta: { title: '余额流水' } },
        { path: '/orderform', component: OrderForm, meta: { title: '订单统计' } },
        { path: '/userinfo', component: UserInfo, meta: { title: '个人信息' } },
        { path: '/fahuoaddress', component: FahuoAddress, meta: { title: '发货地址' } },
        { path: '/address', component: Address, meta: { title: '收货地址' } },

        { path: '/safety', component: Safety, meta: { title: '账户安全' } },
        { path: '/systemnew', component: SystemNew, meta: { title: '系统信息' } },
        { path: '/orderreminder', component: OrderReminder, meta: { title: '订单提醒' } },
        { path: '/promotions', component: Promotions, meta: { title: '促销活动' } },
        { path: '/batchorder', component: BatchOrder, meta: { title: '快速下单' } },
        { path: '/outgotingOrder', component: OutgotingOrder, meta: { title: '外发待处理订单' } },
        { path: '/custOrder', component: CustOrder, meta: { title: '自定义下单' } },



        { path: '/usermoney', component: Usermoney, meta: { title: '余额流水' } },
        { path: '/billrechange', component: Billrechange, meta: { title: '充值报表' } },
        { path: '/water', component: Water, meta: { title: '流水报表' } },
        { path: '/billindex', component: Billindex, meta: { title: '消费报表' } },
        { path: '/aftersale', component: Aftersale, meta: { title: '售后退款' } },
        { path: '/quxiaorechange', component: Quxiaorechange, meta: { title: '取消退款' } },
        { path: '/third', component: Third, meta: { title: '第三方流水' } },
        { path: '/monthlyreport', component: Monthlyreport, meta: { title: '消费月报' } },

        { path: '/daikeOrder', component: DaikeOrder, meta: { title: '代客下单' },beforeEnter: async (to, from, next) => {
          if (window.localStorage.getItem('token')) {
            let data = new FormData()
            data.append('token', window.localStorage.getItem('token'))
            const { data: res } = await axios.post('api/mine/index', data)
            if (res.data.is_server != 1) {
              next('/order')
              return
            }
            next()
          }
          next()
      }},
        { path: '/YunPan', component: YunPan, meta: { title: '我的云盘' } },
      ],
      beforeEnter: (to, from, next) => {
        if (window.localStorage.getItem('token') !== null) {
          return next()
        }
        next('/login')
      }
    },
    // 报价
    {
      path: '/quoteprice', component: QuotePrice, meta: { title: '报价中心' }, redirect: '/quoteprice/content',
      children: [
        { path: '/quoteprice/index', component: QuoteIndex, meta: { title: '报价中心' } },
        { path: '/quoteprice/content', component: Content, meta: { title: '加载中' } }
      ]
    }
    ,
    //关于我们
    {
      path: '/newList', component: Aboutus, meta: { title: '关于我们' },
      children: [
        { path: '/aboutour', component: Aboutour, meta: { title: '关于我们' } },
        { path: '/equipment', component: Equipment, meta: { title: '生产设备' } },
        { path: '/center', component: Center, meta: { title: '产品中心' } },
        { path: '/contactus', component: Contactus, meta: { title: '联系我们' } },
        { path: '/agreement', component: Agreement, meta: { title: '用户协议' } },
      ]
    },
    // { path: '/demo', component: demo }
  ]
})
router.beforeEach(async (to, from, next) => {
  if (window.localStorage.getItem('token')) {
    let data = new FormData()
    data.append('token', window.localStorage.getItem('token'))
    const { data: res } = await axios.post('api/mine/index', data)
    if (res.data === null) {
      window.localStorage.clear()
      window.sessionStorage.clear()
      next('/login')
      return
    }
    next()
  }
  next()
})

export default router
